import { render } from "./ChangeNursery.vue?vue&type=template&id=57684865&ts=true"
import script from "./ChangeNursery.vue?vue&type=script&lang=ts"
export * from "./ChangeNursery.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__